<template>
  <div>
    <div class="d-flex align-center" :class="alignData[align]">
      <v-chip small class="d-inline-flex px-1 py-1 mr-1 grey lighten-2" label>
        <img height="100%" class="mr-2" :src="getFlag(currentCode)" />
        <div class="mr-1">{{ getCurrent("language") }}</div>
        <div v-show="isExists(currentCode) && currentCode !== apiLanguage">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-small
                v-on="on"
                v-bind="attrs"
                @click="deleteLangData(currentCode)"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </template>
            <span>Kaldır</span>
          </v-tooltip>
        </div>
      </v-chip>
      <v-menu class="language-list" min-width="120" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            class="black--text text--lighten-4 elevation-1"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon size="20">mdi-translate</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="currentCode" mandatory>
            <v-list-item
              :value="languageCode"
              class="px-2"
              dense
              :key="languageCode"
              v-for="(langData, languageCode) in languageStructuredData.apiLanguages"
            >
              <v-list-item-avatar tile size="25" height="auto">
                <img width="25px" :src="getFlag(languageCode)"  alt="Flag"/>
              </v-list-item-avatar>
              <v-list-item-title>{{ langData.language }}</v-list-item-title>
              <v-list-item-action v-show="isExists(languageCode)">
                <v-icon size="15">mdi-check</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>
    <slot :data="languageStructuredData._l_data[currentCode]" :currentCode="currentCode"></slot>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LanguageStructuredData from "@/core/modules/LanguageStructuredData";

export default {
  name: "LanguageStructuredData",
  props: {
    value: {
      required: true
    },
    defaultLanguageCode: {
      type: String,
    },
    align: {
      default: "end",
      type: String
    }
  },
  data: () => ({
    languageStructuredData: null,
    currentCode: null,
    currentDetail: null,
    langData: {},
    data: {},
    alignData: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end"
    },
    lastActiveCode: null,
    /**
     * Veri girişi yapılmış diller
     */
    activeLangs: {}
  }),
  computed: {
    ...mapState({
      languagesDetails: state => state.Language.languagesDetails,
      apiLanguage: state => state.Language.apiLanguage
    }),
    ...mapGetters({
      convertLangData: "Language/convertLangData"
    })
  },
  methods: {
    getLanguageCode(lang) {
      return lang.substring(3, 5).toLowerCase();
    },
    getFlag(lang) {
      return require("@/assets/country-flags/" +
        this.getLanguageCode(lang) +
        ".png");
    },
    getCurrent(name) {
      let currentDetail = {
        ...this.currentDetail,
        code: this.currentCode
      };

      return this.parseReference(currentDetail[name]);
    },
    parseReference(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    /**
     * langData üzerinden bir dili siler
     * @param languageCode
     */
    deleteLangData(languageCode) {
      this.setCurrentToDefault();
      this.languageStructuredData.removeLanguageFromData(languageCode);
    },
    /**
     * Dil aktif mi değil mi kontrolü yapar
     */
    isActive(langCode) {
      if (this.langData[langCode] !== undefined) {
        return true;
      } else {
        return false;
      }
    },
    isExists(languageCode) {
      return this.languageStructuredData.languageIsPrepared(languageCode);
    },
    /**
     * Gerçerli dili değiştirir
     */
    setCurrent(languageCode) {
      this.currentCode = languageCode;

      this.currentDetail = this.languageStructuredData.getLanguageDetail(languageCode)

      if (!this.languageStructuredData.languageIsPrepared(languageCode)) {
        this.languageStructuredData.prepareToAnotherLanguage(languageCode);
      }

      const { currentCode, currentDetail } = this;
      this.$emit('change', { oldCode: this.lastActiveCode, currentCode, currentDetail, _l_data: this.languageStructuredData._l_data })
    },

    setCurrentToDefault() {
      this.currentCode = this.apiLanguage;
    },

    /**
     * İçerdeki datayı resetler ve seçili dilleri sıfırlar
     */
    // resetLangData() {
    //   Object.keys(this.langData).forEach(lang => {
    //     this.resetFn(this.langData[lang]);
    //   });
    //
    //   let resetData = {},
    //     def = this.apiLanguage;
    //
    //   resetData[def] = this.parseReference(this.langData[def]);
    //
    //   this.langData = resetData;
    //   this.setCurrent(def, resetData);
    // },
    /**
     * Reset recursive
     *
     * @param {mixed}
     *
     * @returns {mixed}
     */
    // resetFn(obj) {
    //   if (obj !== null && obj !== "") {
    //     if (typeof obj === "object") {
    //       if (obj.constructor !== Array) {
    //         Object.keys(obj).forEach(key => {
    //           if (typeof obj[key] === "object") {
    //             this.resetFn(obj[key]);
    //           } else {
    //             obj[key] = "";
    //           }
    //         });
    //       } else {
    //         obj = [];
    //       }
    //     } else {
    //       obj = "";
    //     }
    //   }
    // },
    /**
     * Emit langData value
     *
     * @param {obj}
     *
     * @returns {void}
     */
    inputEmit(langData) {
      this.$emit("input", langData);
      this.$emit("update:lang", {
        ...this.currentDetail,
        code: this.currentDetail.code
      });
    }
  },
  created() {
    this.languageStructuredData = new LanguageStructuredData({
      _l_data: this.value
    });

    // default olarak geçerli dili set et
    this.currentCode = this.languageStructuredData.apiLanguage;

    // Geçerli dil üzerinden dil detayını al
    this.currentDetail = this.languageStructuredData.getLanguageDetail(this.currentCode);

    // /**
    //  * Value değeri girildiğinde gelen veriyi dillere
    //  * bölerek "langData" oluştur.
    //  */
    // let data = this.value;
    //
    // this.currentDetail = this.languagesDetails[this.current];
    // // Detaylı listeden tüm dil kodlarını al
    // this.apiLanguageCodes = Object.keys(this.languagesDetails);
    // // Ekleme ise veriyi yapılandır
    // if (this.isAdd) {
    //   let langData = {},
    //     dataProcess = [];
    //
    //   this.apiLanguageCodes.forEach(lang => {
    //     langData[lang] = this.parseReference(data);
    //   });
    //
    //   this.langDatas = langData;
    //
    //   this.setCurrent(
    //     this.apiLanguage,
    //     this.parseReference(this.langDatas[this.apiLanguage])
    //   );
    // } else {
    //   let langData = {}
    //
    //   this.apiLanguageCodes.forEach(lang => {
    //     langData[lang] = this.parseReference(this.value);
    //   })
    //
    //   this.langDatas = langData;
    // }
  },
  watch: {
    /**
     * Geçerli değer her değiştiğinde "current" ve "currentLanguage" yi
     * güncelle. Değer her değiştiğinde de $emit("change") oluştur.
     */
    currentCode: {
      handler(value, oldValue) {
        this.lastActiveCode = oldValue;
        this.setCurrent(value);
      },
    },

    defaultLanguageCode(value) {
      this.currentCode = value;
    }
    /**
     * Data her değiştiğinde geçerli dile ait veriyi de "langData"
     * üzerinde güncelle.
     */
    // data: {
    //   handler(value) {
    //     this.langData[this.getCurrent("code")] = this.parseReference(value);
    //   },
    //   deep: true
    // },
    // reset() {
    //   if (this.isAdd) {
    //     this.resetLangData();
    //     this.$emit("reset", true);
    //   }
    // },
    // edit: {
    //   handler(editData) {
    //     if (this.isEdit) {
    //       // Store getters üzerinden data'yı convert et
    //       this.setLangData(this.convertLangData(editData));
    //     }
    //   }
    // }
  }
};
</script>

<style></style>
